import { NetworkIntegrityAggregateKey } from "@app/projects/enumerators";

export const attestationBasedAlertDisplayKeyToAggregateKey = new Map([
    ["Closed Location", NetworkIntegrityAggregateKey.ClosedLocation],
    ["Retired Practitioner", NetworkIntegrityAggregateKey.RetiredPractitioner],
    ["Left Office", NetworkIntegrityAggregateKey.LeftOffice],
    ["Not Recognized", NetworkIntegrityAggregateKey.NotRecognized],
    ["No Longer on Roster", NetworkIntegrityAggregateKey.NoLongerOnRoster],
    ["Termed on Roster", NetworkIntegrityAggregateKey.TermedOnRoster],
]);

export const optionExclusionDisplayKeyToAggregateKey = new Map([
  ["Deactivated NPIs", NetworkIntegrityAggregateKey.DeactivatedNpi],
  ["Invalid NPIs", NetworkIntegrityAggregateKey.InvalidNpi],
  ["Missing NPIs", NetworkIntegrityAggregateKey.MissingNpi],
  ["OIG Exclusions", NetworkIntegrityAggregateKey.OigExclusion],
  ["Medicare Opt Out", NetworkIntegrityAggregateKey.MedicareOptOut],
  ["Medicare Preclusions", NetworkIntegrityAggregateKey.MedicarePrecluded]
]);